import React from 'react'
import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import CompareIcon from 'LuxKit/Icons/custom/CompareIcon'
import RecordIcon from 'LuxKit/Icons/custom/RecordIcon'
import MatchIcon from 'LuxKit/Icons/custom/MatchIcon'

const content = {
  header: {
    title: 'Our Best Price Holiday Guarantee',
    subTitle: 'Luxury Escapes has a Best Price on Earth Holiday Guarantee. If you find a better price online, we’ll match it!',
  },
  negotiation: {
    title: 'We negotiate the best prices so you don’t have to',
    subTitle: 'Here’s how we do it:',
    listItems: [
      {
        text: 'Our global team of experts are dedicated to finding the best holidays for you and your family',
        icon: <LineCheckIcon colour="primary" />,
      },
      {
        text: 'We work directly with the top hotels, resorts and cruise brands around the world',
        icon: <LineCheckIcon colour="primary" />,
      },
      {
        text: 'Together we curate the best value holiday packages with VIP inclusions so you get more from your escape',
        icon: <LineCheckIcon colour="primary" />,
      },
    ],
  },
  howItWorks: {
    title: 'How Our Best Price Guarantee Works',
    subTitle: 'In the unlikely event that you find a better price for the same deal, we’ll promise to match it',
    items: [
      {
        title: 'Compare the Same Deal',
        text: 'Make sure the deal you’ve found is for the same hotel with the same VIP inclusions as our package.',
        icon: <CompareIcon colour="primary" size={68} />,
      },
      {
        title: 'Record the Better Price',
        text: 'Take a website screenshot or a photo of a catalogue so you can send it to us.',
        icon: <RecordIcon colour="primary" size={68} />,
      },
      {
        title: 'We’ll Match the Price',
        text: 'Once verified we’ll match the price.',
        icon: <MatchIcon colour="primary" size={68} />,
      },
    ],
  },
}

export default content
